import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	confirmationMessage: {
		id: 'color-picker.color-validation-messages.confirmation-message',
		defaultMessage: 'Color selection added',
		description:
			'Confirmation message for custom palette when current value of color input is successfully elevated to curated palette',
	},
	errorMessage: {
		id: 'color-picker.color-validation-messages.error-message',
		defaultMessage: 'Enter a valid color',
		description:
			'Error message for custom palette when current value of color input is invalid or empty',
	},
	contrastRatioPassMessage: {
		id: 'color-picker.color-validation-messages.contrast-ratio-pass-message',
		defaultMessage: 'Passes accessibility standards',
		description:
			'Confirmation message for custom palette when current value of color input passes accessibility standards',
	},
	contrastRatioFailMessage: {
		id: 'color-picker.color-validation-messages.contrast-ratio-fail-message',
		defaultMessage: 'Does not pass accessibility standards',
		description:
			'Error message for custom palette when current value of color input does not pass accessibility standards',
	},
});
